/**
 * Cockpit PulseDot — pulsing attention signal.
 * Tones: up (green), warn (amber), info (blue), down (red), idle.
 */
export interface PulseDotProps {
  tone: 'up' | 'warn' | 'info' | 'down' | 'idle';
  pulse?: boolean;
  title?: string;
}

export default function PulseDot({ tone, pulse = true, title }: PulseDotProps) {
  return <span className={`pulse-dot pulse-dot--${tone}${pulse ? ' is-pulsing' : ''}`} title={title} />;
}
